import actions from './actions';

const {
  GET_DATA_BEGIN,
  GET_DATA_SUCCESS,
  GET_DATA_ERR,
  SET_NEW_WARRANTY,
  SET_EDIT_WARRANTY,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const warrantiesReducer = (state = initialState, action: any) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_DATA_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_SUCCESS:
      return {
        ...state,
        data: data.results || data, // Handle both paginated and simple arrays
        loading: false,
      };
    case GET_DATA_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case SET_NEW_WARRANTY:
      return {
        ...state,
        data: [data, ...state.data],
        loading: false,
      };
    case SET_EDIT_WARRANTY:
      return {
        ...state,
        data: state.data.map((item: any) => (item.id === data.id ? data : item)),
        loading: false,
      };
    default:
      return state;
  }
};

export { warrantiesReducer };
